module.exports = __webpack_public_path__ + "img/ingenico.38db8321.svg";